module.exports = __webpack_public_path__ + "img/banner8px_cropped.f9836d12.jpg";